import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LazyLoad, { forceCheck } from "react-lazyload";
import { Tooltip } from "antd";
import {
  dispatchAddCompareList,
  dispatchSubCompareList,
  dispatchModalShow,
  dispatchTipStatus,
  dispatchFollowProduct,
} from "../../../../../store/search/actionCreator";
import { PREFIX_PRODUCT_DETAIL } from "../../../../../utils/constants";
import styles from "../index.module.scss";
import { formatPrice } from "../../../../../utils";

const defaultImg = (
  <img
    src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif"
    alt="default img"
  />
);
const handleImgUrl = (url) => {
  //   if(Config.isSupportWebP && _self.hasClass("useWebP")) {
  // let original;
  //   if(original.indexOf(".jpg") > 0) {
  //       original = original.replace(/.jpg$/, ".jpg!q90.webp");
  //   } else if(original.indexOf(".png") > 0) {
  //       original = original.replace(/.png$/, ".png.webp");
  //   }
  // } else {
  const original = url.replace(/.jpg$/, ".jpg!q90");
  // }
  return original;
};
function ProductCard(props) {
  const { item, comment, shopIcon } = props;

  const dispatch = useDispatch();

  const {
    allData,
    productsListStyle,
    // advertisements,
    compareList,
    modalShow,
    itemTagInfo,
    productsFollowStatus,
    isPlus95,
    productsPriceInfo,
    itemPriceInfo
  } = useSelector((state) => state.searchReducer);

  const { isLogin } = useSelector((state) => state.commonReducer);

  const [pImg, setPImg] = useState("");
  const [pImgIndex, setPImgIndex] = useState(0);
  const [skuId, setSkuId] = useState("");
  const [prevDisabled, setPrevDisabled] = useState(true);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [distance, setDistance] = useState(0);
  const scrollRef = useRef(null);
  const scrollLiRef = useRef(null);

  useEffect(() => {
    setPImg(item.skuImage);
    setSkuId(item.skuId);
  }, [item]);

  useEffect(() => {
    forceCheck();
  }, []);
  
  const showExtraPrice = () => {
    const price = productsPriceInfo?.[skuId]?.fieldMap;
    if (!price) return;
    if (price[2]) {
      // plusPrice
      return (
        <>
          <div className={styles["p-plus"]}>&yen;{price[2]}</div>
          <i className={styles["logo-plus"]}></i>
        </>
      );
    } else if (price[4]) {
      // samPrice
      return (
        <>
          <div className={styles["p-sam"]}>&yen;{price[4]}</div>
          <i className={styles["logo-sams"]}></i>
        </>
      );
    } else if (price[8]) {
      // newMemberPrice
      return (
        <>
          <div className={styles["p-nup"]}>&yen;{price[8]}</div>
          <i className={styles["logo-nup"]}></i>
        </>
      );
    }
  };

  const showProductName = () => {
    const skuId = item?.skuId;
    const tags = itemTagInfo?.[skuId];
    const tagImgUrl = tags?.self
      ? "https://storage.360buyimg.com/jxfe/ppms/c/202411/19/5c893a0a-af5f-4c04-af0a-5c55320ffaaa.png"
      : "https://storage.360buyimg.com/jxfe/ppms/c/202411/19/41a1e3e7-b906-4cee-9cc6-72b628412ba7.png";
    // const ad = advertisements?.filter(item => item.id === `AD_${skuId}`);
    let productName;
    if (tags?.jdChoose) {
      // productName = `<i class=${styles["name-icon-jx"]}></i>` + item.skuName + ' ' + `<i class="${styles["name-other"]}">` + ad[0]?.ad + '</i>';
      productName = `<i class=${styles["name-icon-jx"]}></i>` + item.skuName;
    } else {
      if (tags?.farfetch) {
        // productName = `<i class=${styles["name-icon-jx"]}></i>` + item.skuName + ' ' + `<i class="${styles["name-other"]}">` + ad[0]?.ad + '</i>';
        productName = `<i class=${styles["name-icon-jx"]}></i>` + item.skuName;
      } else {
        // productName = `<i class=${styles["name-icon-glo"]}>全球购</i>` + item.skuName + ' ' + `<i class="${styles["name-other"]}">` + ad[0]?.ad + '</i>';
        // productName = `<i class=${styles["name-icon-glo"]}>${tags?.self ? '自营' : ''}全球购</i>` + item.skuName;
        productName =
          `<img class=${styles["name-icon-glo"]} src=${tagImgUrl} />` +
          item.skuName;
      }
    }
    return productName;
  };

  const handleCheckCompare = () => {
    !modalShow && dispatch(dispatchModalShow(true));
    if (compareList.filter((item) => item.skuId == skuId).length) {
      let _compareList = [...compareList];
      _compareList = _compareList.filter((item) => item.skuId != skuId);
      dispatch(dispatchSubCompareList(_compareList));
    } else {
      dispatch(dispatchAddCompareList({ ids: skuId }));
      if (compareList.length >= 4) {
        dispatch(
          dispatchTipStatus({
            tipShow: true,
            tips: "\u5bf9\u6bd4\u680f\u5df2\u6ee1\uff0c\u60a8\u53ef\u4ee5\u5220\u9664\u4e0d\u9700\u8981\u7684\u680f\u5185\u5546\u54c1\u518d\u7ee7\u7eed\u6dfb\u52a0\u54e6\uff01",
          })
        );

        setTimeout(() => {
          dispatch(
            dispatchTipStatus({
              tipShow: false,
              tips: "",
            })
          );
        }, 5000);
      }
    }
  };

  const handleScrollPrev = () => {
    const itemWidth = scrollLiRef.current.clientWidth;
    let _distance = distance;
    if (distance >= 0) return;
    _distance += itemWidth;
    setNextDisabled(false);
    setDistance(_distance);
    if (_distance == 0) setPrevDisabled(true);
  };

  const handleScrollNext = () => {
    const itemNum = item.colorItems?.length + 1;
    const itemWidth = scrollLiRef.current.clientWidth;
    const totalLength = (itemNum - 6) * itemWidth;
    if (distance + totalLength <= 0) return;
    let _distance = distance;
    _distance -= itemWidth;
    setPrevDisabled(false);
    setDistance(_distance);
    if (_distance + totalLength == 0) setNextDisabled(true);
  };

  const handleImageEnter = (url, showIndex, skuId) => {
    setPImg(url);
    setPImgIndex(showIndex);
    setSkuId(skuId);
  };

  const handleFollowProduct = () => {
    if (isLogin) {
      !productsFollowStatus[item.skuId] &&
        dispatch(dispatchFollowProduct(item.skuId));
    } else {
      window.open(
        `//passport.jd.com/new/login.aspx?ReturnUrl=${encodeURIComponent(
          document.location.toString()
        )}`
      );
    }
  };
  
  return (
    <li className={styles["gl-item"]}>
      <div className={styles["p-tab"]}>
        <ul>
          {item.suiteItems?.length > 0 && <li className={styles.curr}>单件</li>}
          {item.suiteItems?.map((suiteItem) => (
            <li>{suiteItem.suiteName}</li>
          ))}
        </ul>
      </div>
      <div className={styles["p-cnt"]}>
        <div className={`${styles.item} ${styles.hasComment}`}>
          {/* 大图 */}
          <div className={styles["p-img"]}>
            <a
              href={`${PREFIX_PRODUCT_DETAIL}/${skuId}.html`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyLoad
                placeholder={defaultImg}
                scroll={true}
                overflow={true}
                scrollContainer={document.getElementById("root")}
              >
                <img src={handleImgUrl(pImg)} alt="" />
              </LazyLoad>
            </a>
            {item.presaleType == "1" && (
              <div className={styles["p-presell-blank"]}>
                <i></i>
                <span>预售中</span>
              </div>
            )}
          </div>
          {/* 轮转图片 */}
          {productsListStyle?.indexOf("v3") >= 0 && (
            <div
              className={`${styles["p-scroll"]} ${
                item?.colorItems?.length >= 6 ? styles.scrolled : null
              }`}
              ref={scrollRef}
            >
              <span
                className={`${styles["ps-prev"]} ${
                  prevDisabled ? styles.disabled : null
                }`}
                onClick={handleScrollPrev}
              >
                &lt;{" "}
              </span>
              <span
                className={`${styles["ps-next"]} ${
                  nextDisabled ? styles.disabled : null
                }`}
                onClick={handleScrollNext}
              >
                &gt;
              </span>
              <div className={styles["ps-wrap"]}>
                <ul className={styles["ps-main"]} style={{ left: distance }}>
                  <li
                    className={`${pImgIndex === 0 ? styles.curr : null}`}
                    ref={scrollLiRef}
                  >
                    <span
                      title={item.colorName}
                      className={`${pImgIndex === 0 ? styles.curr : null}`}
                      onMouseEnter={() =>
                        handleImageEnter(item.skuImage, 0, item.skuId)
                      }
                    >
                      <LazyLoad
                        placeholder={defaultImg}
                        scroll={true}
                        overflow={true}
                        scrollContainer={document.getElementById("root")}
                      >
                        <img src={handleImgUrl(item.skuImage)} alt="" />
                      </LazyLoad>
                    </span>
                  </li>
                  {item.colorItems?.map((colorItem, colorItemIndex) => (
                    <li
                      className={`${
                        pImgIndex === colorItemIndex + 1 ? styles.curr : null
                      }`}
                      skuid="J_$!ci.skuId"
                      key={colorItem.skuId}
                    >
                      <span
                        title={colorItem.colorName}
                        className={`${
                          pImgIndex === colorItemIndex + 1 ? styles.curr : null
                        }`}
                        onMouseEnter={() =>
                          handleImageEnter(
                            colorItem.skuImage,
                            colorItemIndex + 1,
                            colorItem.skuId
                          )
                        }
                      >
                        <LazyLoad
                          placeholder={defaultImg}
                          scroll={true}
                          overflow={true}
                          scrollContainer={document.getElementById("root")}
                        >
                          <img src={handleImgUrl(colorItem.skuImage)} alt="" />
                        </LazyLoad>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          {/* 价格 */}
          <div className={styles["price-icons"]}>
            <div className={styles.price}>
              <span>
                <b>&yen;</b>
                {itemPriceInfo?.[skuId]?.price?.pprice >= 0
                  ? itemPriceInfo?.[skuId]?.price?.pprice
                  : "--"}
              </span>
              <div className={styles.sam}>{showExtraPrice()}</div>
            </div>
          </div>
          {/* 商品名称 */}
          <div
            className={
              styles["p-name"]
            } /*isChoose="$!itemTagUtils.isJdChoose($!item)" isFarfetch="$!itemTagUtils.isFarfetch($!item)"*/
          >
            <a
              href={`${PREFIX_PRODUCT_DETAIL}/${skuId}.html`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <em dangerouslySetInnerHTML={{ __html: showProductName() }}></em>
            </a>
          </div>
          {/* 商品评价 */}
          <div className={styles["p-buy"]}>
            <div className={styles.assess}>
              <a
                href={`//${PREFIX_PRODUCT_DETAIL}/${item.skuId}.html#comments-list`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.comment}
              >
                <span className={styles.cNum}>
                  <b className={styles["comment_num"]}>{comment}</b> 条评价
                </span>
              </a>
            </div>
          </div>
          {/* 店铺名称 */}
          <div className={styles["p-shop-name"]}>
            <p>
              <a
                className={styles["p-shop-name-text"]}
                href={`http://mall.jd.hk/index-${item.shopId}.html`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.shopName}
              </a>
              <a
                className={`${styles["p-shop-name-icon"]} ${
                  item.shopName &&
                  (shopIcon?.code == "1" || shopIcon?.code == "3")
                    ? styles["shop-icon-new"]
                    : null
                }`}
                href={`http://chat.jd.com/chat/index.action?venderId=${item.venderId}&entry=sup_web_search`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
              </a>
            </p>
          </div>
          {/* icon */}
          <div className={styles["p-icons"]} style={{ maxWidth: "200px" }}>
            {
              // 保证原有逻辑不变，只针对京东全球购的标进行合并
              itemTagInfo?.[item.skuId]?.self &&
              (itemTagInfo?.[skuId]?.jdChoose ||
                itemTagInfo?.[skuId]?.farfetch) ? (
                <Tooltip
                  title="京东自营，品质保障"
                  placement="bottomLeft"
                  color={"#fff"}
                  overlayInnerStyle={{ color: "#666", minHeight: 0 }}
                >
                  <i className={`${styles.icons} ${styles["serch_zy"]}`}>
                    自营
                  </i>
                </Tooltip>
              ) : itemTagInfo?.[item.skuId]?.jdExp ? (
                <Tooltip
                  title="京东物流仓配，商家提供售后服务"
                  placement="bottom"
                  color={"#fff"}
                  overlayInnerStyle={{ color: "#666", minHeight: 0 }}
                >
                  <i className={`${styles.icons} ${styles["serch_exp"]}`}>
                    京东物流
                  </i>
                </Tooltip>
              ) : null
            }
            {itemTagInfo?.[item.skuId]?.fxg && (
              <Tooltip
                title="品质服务，放心购物"
                placement="bottomLeft"
                color={"#fff"}
                overlayInnerStyle={{ color: "#666", minHeight: 0 }}
              >
                <i className={`${styles.icons} ${styles["serch_fxg"]}`}>
                  放心购
                </i>
              </Tooltip>
            )}
            {isPlus95 && itemTagInfo?.[item.skuId]?.plus95 && (
              <Tooltip
                title="该商品享受Plus会员95折"
                placement="bottomLeft"
                color={"#fff"}
                overlayInnerStyle={{ color: "#666", minHeight: 0 }}
              >
                <i className={`${styles.icons} ${styles["serch_plus95"]}`}>
                  PLUS95折
                </i>
              </Tooltip>
            )}
            {itemTagInfo?.[item.skuId]?.quaTrace && (
              <Tooltip
                title="好品质，看得见"
                placement="bottomLeft"
                color={"#fff"}
                overlayInnerStyle={{ color: "#666", minHeight: 0 }}
              >
                <i className={`${styles.icons} ${styles["serch_pz"]}`}>
                  品质溯源
                </i>
              </Tooltip>
            )}
            {itemTagInfo?.[item.skuId]?.fzxp && (
              <Tooltip
                title="该商品是当季新品"
                placement="bottomLeft"
                color={"#fff"}
                overlayInnerStyle={{ color: "#666", minHeight: 0 }}
              >
                <i className={`${styles.icons} ${styles["serch_new"]}`}>新品</i>
              </Tooltip>
            )}
            {itemTagInfo?.[item.skuId]?.couponTag !== "" && (
              <Tooltip
                title="本商品可领用优惠券"
                placement="bottomLeft"
                color={"#fff"}
                overlayInnerStyle={{ color: "#666", minHeight: 0 }}
              >
                <i className={`${styles.icons} ${styles["serch_coupon"]}`}>
                  券{itemTagInfo?.[item.skuId]?.couponTag}
                </i>
              </Tooltip>
            )}
            {itemTagInfo?.[item.skuId]?.reductionTag && (
              <Tooltip
                title="本商品参与满减促销"
                placement="bottomLeft"
                color={"#fff"}
                overlayInnerStyle={{ color: "#666", minHeight: 0 }}
              >
                <i className={`${styles.icons} ${styles["serch_mj"]}`}>满减</i>
              </Tooltip>
            )}
            {itemTagInfo?.[item.skuId]?.giftTag && (
              <Tooltip
                title="购买本商品送赠品"
                placement="bottomLeft"
                color={"#fff"}
                overlayInnerStyle={{ color: "#666", minHeight: 0 }}
              >
                <i className={`${styles.icons} ${styles["serch_zeng"]}`}>赠</i>
              </Tooltip>
            )}
            {item?.tax == "2" && (
              <i className={`${styles.icons} ${styles["serch_tax"]}`}>包税</i>
            )}
          </div>
          {/* 对比-参与抢购-加入购物车 */}
          <div className={styles.other}>
            {allData.skuFallowPCSwitch == "ON" && (
              <div
                className={`${styles["cj-concern"]} ${
                  productsFollowStatus[item.skuId] ? styles.selected : null
                }`}
                onClick={handleFollowProduct}
              >
                <i></i>
                <em>{productsFollowStatus[item.skuId] ? "已" : ""}关注</em>
              </div>
            )}
            <div
              className={styles["p-operate"]}
              style={
                allData.skuFallowPCSwitch !== "ON"
                  ? { paddingLeft: "115px" }
                  : {}
              }
            >
              <span
                className={`${styles["p-o-btn"]} ${styles.contrast} ${
                  compareList.filter((item) => item.skuId == skuId).length
                    ? styles.selected
                    : null
                }`}
                onClick={handleCheckCompare}
              >
                <i
                  style={
                    allData.skuFallowPCSwitch !== "ON"
                      ? { paddingLeft: "100px" }
                      : {}
                  }
                ></i>
                对比
              </span>
            </div>
            {item.presaleType == "1" ? (
              <div className={styles["presale_cyqg"]}>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(`${PREFIX_PRODUCT_DETAIL}/${item.skuId}.html`);
                  }}
                >
                  <i></i>
                  <em>参与抢购</em>
                </span>
              </div>
            ) : (
              <div className={styles.addCart}>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    const url = `https://cart.jd.com/gate.action?pid=${item.skuId}&pcount=1&ptype=1`;
                    window.open(
                      isLogin
                        ? url
                        : `//passport.jd.com/new/login.aspx?ReturnUrl=${encodeURIComponent(
                            url
                          )}`
                    );
                  }}
                >
                  <i></i>
                  <em>加入购物车</em>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </li>
  );
}

export default ProductCard;
